
import React from "react";
import styled from "styled-components";

import cleaning from "../assets/img/service-1-cleaning.png";
import polishing from "../assets/img/service-2-polishing.png";
import commercial from "../assets/img/service-3-commercial.png";
import handyman from "../assets/img/service-4-handyman.png";
import outdoor from "../assets/img/service-5-outdoor.png";
import maintenance from "../assets/img/service-6-maintenance.png";

const services = [
  {
    img: cleaning,
    icon: "♧",
    title: "עובדי ניקיון וצוותי ניקיון",
    text: "לפתוח את הבוקר במשרד נקי, רענן ומזמין. חברתנו מספקת צוותי ניקיון מקצועיים בסטנדרט הגבוה ביותר ובמחירים המשתלמים בשוק, כדי שתוכלו להתרכז במה שחשוב באמת – העסק שלכם. זמינות : צוותי הניקיון זמינים לפי הצרכים שלכם. מקצועיות ללא פשרות : עובדים מנוסים, מיומנים ומפוקחים המקפידים על כל פרט. התאמה אישית מלאה: תוכנית ניקיון ייעודית המותאמת לגודל המשרד ואופי הפעילות בו. המשתלם ביותר לעסק : שירות פרימיום בתוצאות, במחירים תחרותיים ואטרקטיביים."
  },
  {
    img: polishing,
    icon: "✧",
    title: "קרצוף פוליש לרצפה ופוליש ווקס",
    text: "מחזירים לרצפה את הברק והמראה המקורי שלה. חברתנו מתמחה בטיפולי פוליש מתקדמים הכוללים קרצוף עמוק להסרת כתמים ולכלוך קשה, ציפוי ווקס איכותי להגנה ולמראה מבריק לאורך זמן, באמצעות מכונות ייעודיות וחומרים מקצועיים."
  },
  {
    img: commercial,
    icon: "▦",
    title: "ניקיון ואחזקות נכסים מסחריים",
    text: "חברתנו מספקת מענה מקיף, מקצועי ומתקדם לכל צורכי הניקיון והתחזוקה במגזר העסקי והמסחרי. אנו מתחייבים לסטנדרט שירות ללא פשרות, תוך התאמה מלאה ללוחות הזמנים של העסק שלכם. השירותים המובילים שלנו : ניקיון משרדים ובנייני מסחר – תחזוקה שוטפת באווירה רעננה ונקייה. ניקיון לאחר שיפוץ – הכנת הנכס מאפס ועד למסירה מושלמת. ניקיון לפני אכלוס – כניסה חלקה, נקייה והיגיינית לנכס החדש שלכם. למה לבחור בנו? טכנולוגיה וחומרים – שימוש במכשור מכאני מתקדם ובחומרי הניקוי המובילים והבטוחים בשוק. תמחור הוגן ושקוף – פתרונות ניקיון מתקדמים במחירים אטרקטיביים ותחרותיים. שקט נפשי מלא – אנו מעניקים אחריות מלאה על איכות וביצוע של כל עבודה בשטח."
  },
  {
    img: handyman,
    icon: "⚒",
    title: "שירותי הנדימן לנכסים מסחריים",
    text: "מענה מקיף לכל תיקון ותחזוקה במבני מסחר, משרדים ועסקים. אנו מטפלים בתיקונים קטנים כגדולים במקצועיות ללא פשרות, תוך דגש על שירות יעיל שאינו מפריע לשגרת העבודה שלכם.המומחיות שלנו בשטח כוללת: תיקוני צבע וגבס – תיקון חורים, סדקים, חידוש קירות משרד וצביעה אסתטית. התקנות ותלייה – תליית מסכים, לוחות מחיקים, גופי תאורה, מדפים ואלמנטים דקורטיביים. תחזוקת ריהוט ודלתות – תיקון והרכבת ריהוט משרדי, כיוון צירים, ידיעות ומנעולים. פתרונות אינסטלציה קלים – החלפת ברזים, פתיחת סתימות קלות וטיפול בנזילות מקומיות. למה לעבוד איתנו? ידי זהב לכל משימה : יכולת מוכחת לחדש, לתקן ולפתור כמעט כל בעיה בנכס. יחס אישי ומנהל זמין: ליווי ישיר של מנהל העסק לאורך כל הדרך. עמידה קפדנית בלוחות זמנים: הגעה בזמן ועבודה מהירה, מדויקת ונקייה. מחירים אטרקטיביים: תמחור הוגן ושקוף המותאם לצרכים של המגזר העסקי. "
  },
  {
    img: outdoor,
    icon: "♧",
    title: "ניקיון שטחים פתוחים וציבוריים",
    text: "חברתנו מספקת שירותי חצרנות על ידי חצרנים מקצועיים אשר מתמחים בניקיון שטחים פתוחים ובשימוש של מכונות ייעודיות לכל שטח בהתאמה, ציוד מכאני מתקדם : שימוש במטאטאים מכאניים, מפוחים ומכונות שטיפה בלחץ, התאמה מלאה לתנאי השטח : ניקוי יעיל של מדרכות, חניונים, פארקים ורחבות ציבוריות.צוות מיומן ומפוקח: חצרנים מקצועיים המקפידים על לוחות זמנים, בטיחות וסטנדרט גבוה.פתרונות בהתאמה אישית : שירות חד-פעמי לאירועים או תחזוקה שוטפת על בסיס קבוע."
  },
  {
    img: maintenance,
    icon: "⚙",
    title: "שירותי אחזקה שוטפת לנכסי מסחר ומבני ציבור",
    text: "חברתנו מספקת מעטפת אחזקה מקיפה ותחזוקה מונעת המותאמת באופן ייחודי לצרכים של כל בניין ונכס. אנו מעמידים לרשותכם שירותי אב בית מקצועיים ומנהלים את כלל מערכות המבנה תחת קורת גג אחת, כדי להבטיח לכם שקט תעשייתי מלא ותפעול רציף. השירותים המקצועיים שלנו כוללים : שירותי אב בית מותאמים : מענה גמיש לפי צורכי הלקוח – החל מהחלפת נורות ותיקונים קטנים, ועד לטיפול וניתוח חשבונות מים גבוהים לאיתור נזילות. תחזוקת מערכות אנרגיה ומים: ניקוי וחיטוי מאגרי מים, ותחזוקה שוטפת של מערכות סולאריות ומשאבות. בטיחות ומערכות חירום: בדיקת ספרינקלרים, תחזוקת רכזות כיבוי אש, והפעלה חודשית כולל טיפול רבעוני לגנרטורים. תשתיות ואוורור : טיפול במערכות המבנה השונות, מעליות ומפוחים. מעטפת שירותים משלימה : שירותי ניקיון יסודיים למבנה ועבודות גינון וטיפוח סביבתי."
  }
];

const Section = styled.section`
  width: 100%;
  padding: 75px 20px 65px;
  position: relative;
  overflow: hidden;
  direction: rtl;

  background:
    radial-gradient(ellipse at 50% 0%, rgba(0, 137, 255, .17), transparent 55%),
    linear-gradient(180deg, #061a35 0%, #031329 55%, #061a35 100%);

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 350px;
    height: 350px;
    border-radius: 50%;
    background: rgba(0, 145, 255, .09);
    filter: blur(100px);
    pointer-events: none;
  }

  &::before {
    top: 0;
    left: -180px;
  }

  &::after {
    bottom: 0;
    right: -180px;
  }

  @media(max-width: 600px) {
    padding: 55px 14px 45px;
  }
`;

const Header = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
  margin: 0 auto 42px;
`;

const Label = styled.div`
  color: #00baff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 6px;
  margin-bottom: 12px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(2.2rem, 4.5vw, 3.5rem);
  font-weight: 900;
  margin: 0 0 13px;
  letter-spacing: -1px;

  span {
    color: #00baff;
  }

  @media(max-width: 600px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  color: rgba(225, 239, 255, .85);
  font-size: 16px;
  line-height: 1.8;
  margin: 0 auto;
  max-width: 750px;

  @media(max-width: 600px) {
    font-size: 14px;
    padding: 0 8px;
  }
`;

const Grid = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1050px;
  margin: auto;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;

  @media(max-width: 650px) {
    grid-template-columns: 1fr;
    max-width: 480px;
    gap: 23px;
  }
`;

const Card = styled.article`
  min-width: 0;
  position: relative;
  display: flex;
  flex-direction: column;

  background: linear-gradient(
    145deg,
    #082b52,
    #031a38 75%
  );

  border: 1px solid #009de8;
  border-radius: 16px;
  overflow: hidden;

  box-shadow: 0 10px 30px rgba(0, 0, 0, .24);

  transition: transform .3s ease, box-shadow .3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 145, 255, .2);
  }

  .image-area {
    position: relative;
    width: 100%;
    aspect-ratio: 456 / 177;
    background: #082b52;
    border-bottom: 3px solid #00baff;
  }

  .service-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  .icon-circle {
    position: absolute;
    z-index: 2;
    right: 20px;
    bottom: -24px;

    width: 70px;
    height: 70px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    background: linear-gradient(145deg, #07366b, #031b3c);
    border: 3px solid #00baff;

    box-shadow: 0 5px 18px rgba(0, 0, 0, .45);

    color: #fff;
    font-size: 27px;
  }

  .content {
    padding: 34px 23px 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  h3 {
    color: #fff;
    font-size: 19px;
    font-weight: 900;
    line-height: 1.5;
    margin: 0 0 12px;
  }

  p {
    color: rgba(225, 239, 255, .88);
    font-size: 15px;
    line-height: 1.95;
    margin: 0;
    text-align: right;
    flex: 1;
  }

  .more {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: #00baff;
    font-size: 15px;
    font-weight: 800;
    margin-top: 18px;
    text-decoration: none;
    width: fit-content;
    transition: .25s;
  }

  .more:hover {
    color: #fff;
    transform: translateX(-4px);
  }

  .more span {
    font-size: 23px;
    line-height: 1;
  }

  @media(max-width: 650px) {
    border-radius: 14px;

    .image-area {
      aspect-ratio: 456 / 177;
    }

    .icon-circle {
      width: 62px;
      height: 62px;
      right: 15px;
      bottom: -22px;
      font-size: 23px;
    }

    .content {
      padding: 33px 18px 20px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 14px;
      line-height: 1.9;
    }

    .more {
      font-size: 14px;
    }
  }

  @media(max-width: 380px) {
    .content {
      padding-left: 14px;
      padding-right: 14px;
    }

    h3 {
      font-size: 16px;
    }

    p {
      font-size: 13px;
    }
  }
`;

const Footer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 22px;
  margin: 48px auto 0;

  span {
    width: 75px;
    height: 2px;
    background: #00baff;
  }

  .brand {
    text-align: center;
  }

  strong {
    display: block;
    color: #fff;
    font-size: 42px;
    font-weight: 900;
    letter-spacing: 3px;
    line-height: 1;
  }

  small {
    display: block;
    color: #00baff;
    font-size: 10px;
    letter-spacing: 2px;
    margin-top: 8px;
  }

  @media(max-width: 600px) {
    gap: 13px;
    margin-top: 35px;

    span {
      width: 45px;
    }

    strong {
      font-size: 34px;
    }

    small {
      font-size: 8px;
      letter-spacing: 1px;
    }
  }
`;

export default function questions({ reference }) {
  return (
    <Section ref={reference}>
      <Header>

        <Title id="השירותים שלנו">
          השירותים <span>שלנו</span>
        </Title>

        <Description>
          מגוון פתרונות מקצועיים לניקיון, אחזקה וניהול מבנים ברמה הגבוהה ביותר
        </Description>
      </Header>

      <Grid>
        {services.map((item, index) => (
          <Card key={index}>
            <div className="image-area">
              <img
                className="service-image"
                src={item.img}
                alt={item.title}
                loading="lazy"
              />

              <div className="icon-circle" aria-hidden="true">
                {item.icon}
              </div>
            </div>

            <div className="content">
              <h3>{item.title}</h3>

              <p>{item.text}</p>

          
            </div>
          </Card>
        ))}
      </Grid>

      <Footer>
        <span />

        <div className="brand">
          <strong> אחזקה וניהול מבנים ברמה הגבוהה ביותר

</strong>
        </div>

        <span />
      </Footer>
    </Section>
  );
}
